import { HttpParams } from '@angular/common/http';

/**
 * Query param baku endpoint panel profil vendor — **SATU sumber untuk endpoint LIST dan endpoint
 * DETAIL** (`.../profile_offices` dan `.../profile_offices/:id`, dst).
 *
 * Ditulis sekali di sini, bukan dua kali di dua service, supaya keduanya tidak bisa berbeda.
 * Kalau berbeda, gejalanya bukan error: BE membalas 200 dengan data yang salah scope-nya — atau
 * 404 untuk record yang sebenarnya ada.
 *
 * - **`vendor_id`** — parameter **WAJIB**, bukan opsional ber-default `'current_user'`. Default
 *   yang diam-diam benar di situs vendor akan diam-diam SALAH begitu halaman yang sama dipakai
 *   admin untuk menelaah vendor lain, dan itu bukan error build
 *   (PLAN-PROFILE-EDIT-REUSE.md §6b). Situs vendor meneruskan literal `'current_user'`; BE sendiri
 *   yang menerjemahkannya ke vendor milik sesi.
 * - **`enable_paging=false`** — pada endpoint LIST ini wajib: validasi butuh semua baris, dan
 *   kalau hanya halaman pertama yang terambil, panel bisa dinyatakan tidak lengkap padahal
 *   dokumennya ada di halaman 2. Pada endpoint DETAIL ia tidak berarti apa-apa (satu record tidak
 *   dipaginasi), tapi tetap ikut dikirim atas instruksi user supaya bentuk request kedua endpoint
 *   persis sama.
 *
 * @param vendorId `'current_user'` (situs vendor) atau UUID vendor (situs admin)
 */
export function panelParams(vendorId: string): HttpParams {
  return new HttpParams().set('vendor_id', vendorId).set('enable_paging', 'false');
}
